!function(d, o, t) {
  
  o = "nav-open";
  t = d.getElementById("nav-toggle");
  
  if(!t) return;
  
  t.onclick = function(e) {
    e.preventDefault();
    var c = d.documentElement.classList;
    (c.contains(o) === true) ? c.remove(o) : c.add(o);
  }
  
}(document)